module.exports = __webpack_public_path__ + "media/images/lb/947-7a5858f6b294742e126865bb59d097f7.svg";